module.exports = __webpack_public_path__ + "img/grid-icon.391b824e.svg";